/* Project Import will be here */
import { post, IRequest } from "./index";
import {
  ILocationMasterParams,
  ICountryParams,
  IStatesParams,
  ICitiesParams,
  IPrinciplesParams
} from "models/commonModels";
/* Project Import will be here */

export const getLocationMasterApi = (data: ILocationMasterParams) => {
  const request: IRequest = {
    subUrl: `/Location/LocationMaster`,
    ...data
  };
  return post(request);
};

export const getCountriesApi = (data: ICountryParams) => {
  const params = {
    data: {
      levelId: 0,
      locId: 0
    },
    headers: data.headers
  };
  return getLocationMasterApi(params);
};

export const getRegionsApi = (data: IRegionsParams) => {
  const params = {
    data: {
      levelId: 1,
      locId: data.locId
    },
    headers: data.headers
  };
  return getLocationMasterApi(params);
};

export const getStatesApi = (data: IStatesParams) => {
  const params = {
    data: {
      levelId: 2,
      locId: data.locId
    },
    headers: data.headers
  };
  return getLocationMasterApi(params);
};

export const getCitiesApi = (data: ICitiesParams) => {
  const params = {
    data: {
      levelId: 3,
      locId: data.locId
    },
    headers: data.headers
  };
  return getLocationMasterApi(params);
};

export const getChannelMasterApi = () => {
  const request: IRequest = {
    subUrl: `/Channel/ChannelMaster`
  };
  return post(request);
};

export const getPrincipalsApi = () => {
  const request: IRequest = {
    subUrl: `/Principal/PrincipalList`
  };
  return post(request);
};

export const getProfilePrincipalsApi = (data: IPrinciplesParams) => {
  const request: IRequest = {
    subUrl: `/Principal/ProfilePrincipalList`,
    headers: data.headers
  };
  return post(request);
};

export const getCategoryMenu = () => {
  const request: IRequest = {
    subUrl: `/Product/DynamicFilter`
  };
  return post(request);
};

export const getDMSUserIdentity = () => {
  const request: IRequest = {
    subUrl: `/Appconfig/GetPublicKey`
  };

  return post(request);
}

export const updateFcmTokenApi = (fcmToken) => {
  const request: IRequest = {
    subUrl: `/AppConfig/UpdateFCM`
  };

  /* Assign FCM token in the request header */
  if (fcmToken !== null)
    request.headers = { 'fcm-token': fcmToken }

  return post(request);
};